import { RoseConfigBlockState } from './types';

const timeRange = 'PT-24H--PT48H'; // from 24 hours ago to 48 hours ahead

const defaultState: RoseConfigBlockState = {
    settings: {
        binCount: 3,
        binStepSize: 1,
        coneCount: 8,
        centerSpace: 20,
        colourScale: 'Green-Blue',
        fontSize: 100,
        timeRange,
        percentageLabelAngle: 6,
        unit: 'm/s',
        unitLabel: 'm/s',
        showDatapoints: false,
        relativeFrequencyAxis: false,
    },
    databilities: [
        {
            id: '1.41421356237',
            capabilityId: null as unknown as string,
            datasetId: null as unknown as string,
            timeRange,
        },
    ],
};

export default defaultState;
